<template>
    <router-view :websiteid="websiteid" :readonly="readonly"/>
</template>

<script>
    import axios from 'axios';

    export default{
        name: "App",
        data: function(){
            return{
                userinfo: JSON.parse(localStorage.getItem('user')),
                readonly: true,
                websiteid: this.$route.params.websiteid // for standalone: window.myAppConfig.websiteid
            }
        },
        methods: {
        },
        mounted(){
        }
    }
</script>